export default __webpack_public_path__ + "static/RobotoMono-italic-1ce08cfde36c0d81af5b60c1a4ab895e.woff";